<template>
	<div>
		<CCard>
			<CCardHeader> Réceptionner un bordereau </CCardHeader>
			<CCardBody>
				<CRow>
					<CCol col="4">
						<CSelect
							label="Méthode de réception"
							:options="receptionTypes"
							:value.sync="receptionType" />
					</CCol>

					<CCol col="4">
						<div class="form-group">
							<label>Produit</label>
							<GTreeView
								input-name="product"
								placeholder="Rechercher un produit"
								:multiple="false"
								v-on:update:selected="data => (receptionProduct = data)"
								:default-options="true"
								:load-options="loadProducts"
								:async="true" />
						</div>
					</CCol>

					<CCol col="4">
						<CInput ref="slipForm" v-model="slipNumber" label="Numéro bordereau" />
					</CCol>

					<CCol col="12">
						<GLoadingButton
							class="d-inline"
							color="primary"
							label="Réceptionner"
							:loading="loading"
							@click="onSubmit" />
						<router-link to="/orders/new">
							<CButton color="primary" class="ml-3">Créer une nouvelle commande</CButton>
						</router-link>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>

		<CCard v-if="orderItem && orderItem['@id']">
			<CCardHeader> Informations sur le bordereau </CCardHeader>
			<CCardBody>
				<CRow>
					<CCol col="6" class="q-name">
						<p>Expéditeur</p>
					</CCol>

					<CCol col="6" class="q-value">
						<p v-if="orderItem.parentOrder && orderItem.parentOrder.senderAddress">
							{{ orderItem.parentOrder.senderAddress.lastName }}
							{{ orderItem.parentOrder.senderAddress.firstName }},
							{{ orderItem.parentOrder.senderAddress.postalCode }}
						</p>
					</CCol>

					<CCol col="6" class="q-name">
						<p>Destinataire</p>
					</CCol>

					<CCol col="6" class="q-value">
						<p v-if="orderItem.receiverAddress">
							{{ orderItem.receiverAddress.lastName }}
							{{ orderItem.receiverAddress.firstName }},
							{{ orderItem.receiverAddress.postalCode }}
						</p>
					</CCol>

					<CCol col="6" class="q-name">
						<p>Point de dépôt</p>
					</CCol>

					<CCol col="6" class="q-value">
						<p v-if="slip.depotPts">[{{ slip.depotPts.reference }}] {{ slip.depotPts.name }}</p>
					</CCol>

					<CCol col="6" class="q-name">
						<p>Point de vente</p>
					</CCol>

					<CCol col="6" class="q-value">
						<p v-if="slip.salePts">[{{ slip.salePts.reference }}] {{ slip.salePts.name }}</p>
					</CCol>

					<CCol col="6" class="q-name">
						<p>Type de colis</p>
					</CCol>

					<CCol col="6" class="q-value">
						<p>{{ orderItem.product.name }}</p>
					</CCol>

					<CCol col="6" class="q-name">
						<p>Poids du colis</p>
					</CCol>

					<CCol col="6" class="q-value">
						<p>{{ orderItem.weightNet }} KG</p>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>

		<CCard v-if="orderItem && orderItem['@id']">
			<CCardHeader>Informations - Commande</CCardHeader>
			<CCardBody>
				<CRow>
					<CCol col="6" class="q-name">
						<p>Numéro de commande</p>
					</CCol>

					<CCol col="6" class="q-value">
						<p>{{ orderItem.parentOrder.id }}</p>
					</CCol>

					<CCol col="6" class="q-name">
						<p>Numéro de colis</p>
					</CCol>

					<CCol col="6" class="q-value">
						<p>{{ orderItem.id }}</p>
					</CCol>

					<CCol col="12" v-if="orderItem.parentOrder">
						<router-link :to="`/orders/${orderItem.parentOrder.id}/edit`">
							<CButton color="primary">Voir la commande</CButton>
						</router-link>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>

		<CCard v-if="orderItem && orderItem['@id']">
			<CCardHeader>Impression d'étiquette</CCardHeader>
			<CCardBody>
				<CRow>
					<CCol col="12">
						<template
							v-if="
								orderItem.receiverAddress &&
								orderItem.price &&
								slip.depotPts &&
								slip.salePts &&
								(orderItem.parentOrder.status === 'order.complete' ||
									orderItem.parentOrder.status === 'order.paid' ||
									orderItem.parentOrder.status === 'order.admin_authorized')
							">
							<CCol col="12">
								<h4 style="color: red" v-if="orderItem.state === 'order_item.label_printed'">
									Attention: Cette étiquette a déjà été imprimée ! <br />
									Assurez-vous d'avoir bien déchiré la première étiquette imprimée !
								</h4>
								<h5 style="color: red" v-if="orderItem.state === 'order_item.scanned'">
									Ce colis a déjà été bipé/scanné !
								</h5>
							</CCol>

							<CCol col="6">
								<select-printer ref="printer" />
							</CCol>

							<CCol col="12">
								<GLoadingButton
									:loading="loading"
									label="Imprimer l'étiquette"
									v-on:click="onSubmitLabelPrint" />
							</CCol>
						</template>

						<template v-else>
							<p>
								La saisie d'informations n'est pas complète sur cette commande ou ce colis et
								l'étiquette ne peut donc pas être imprimée.
							</p>
						</template>
					</CCol>
				</CRow>
			</CCardBody>
		</CCard>
	</div>
</template>

<script>
	import GLoadingButton from '../../../components/ghostlexly-components/GLoadingButton';
	import SelectPrinter from '../../../components/select-printer';
	import GTreeView from '../../../components/ghostlexly-components/GTreeView';

	export default {
		name: 'receive',
		components: { SelectPrinter, GLoadingButton, GTreeView },
		data() {
			return {
				loading: false,
				orderItem: {},
				slip: {},
				slipNumber: null,
				receptionProduct: null,
				receptionType: 'slip.reception_fax',
				receptionTypes: [
					{ label: 'Fax', value: 'slip.reception_fax' },
					{ label: 'Dépôt', value: 'slip.reception_depot' },
					{ label: 'Colipays', value: 'slip.reception_colipays' },
					{ label: 'Mail', value: 'slip.reception_mail' },
				],
			};
		},

		methods: {
			onSubmit() {
				this.orderItem = {};
				this.slip = {};

				if (!this.receptionProduct) {
					this.$toast.error('Veuillez choisir un produit de réception.');
					return false;
				}

				this.loading = true;

				this.$axios
					.patch(`/api/slips/receive/${this.slipNumber}`, {
						receptionMethod: this.receptionType,
						receptionProduct: this.receptionProduct,
					})
					.then(res => {
						this.$toast.success(`Le bordereau ${this.slipNumber} a bien été receptionné.`);
						this.slipNumber = null;
						this.$refs.slipForm.$el.querySelector('input').focus();

						if (res.data.completedOrderItem) {
							this.slip = res.data;
							this.orderItem = res.data.completedOrderItem;
						}

						this.loading = false;
					})
					.catch(err => {
						this.loading = false;
						if (err.response.status === 404) {
							this.$toast.error(`Le bordereau ${this.slipNumber} n'existe pas.`);
						} else {
							this.$toast.error(
								'Un problème est survenu, veuillez contacter les développeurs.'
							);
						}
					});
			},

			onSubmitLabelPrint() {
				if (!confirm("Êtes-vous sûr d'avoir déchiré la première étiquette déjà imprimée ?")) {
					return false;
				}

				if (!this.$qz.websocket.isActive()) {
					this.$toast.error(
						"Veuillez vous connecter à l'imprimante avant de pouvoir imprimer des étiquettes."
					);
					return false;
				}

				this.$axios
					.get(
						`${this.orderItem['@id']}/label?sendingDate=${this.$moment().format('YYYY-MM-DD')}`,
						{
							timeout: 3600000,
						}
					)
					.then(res => {
						this.$refs.printer.send(res.data.zpl).then(o => {
							this.loading = false;
							this.showModal = false;

							if (o === true) {
								this.$toast.success("Les étiquettes ont été transmises à l'imprimante.");
								this.$refs.slipForm.$el.querySelector('input').focus();
							} else {
								this.$toast.error(
									"Un problème est survenu lors de transmission des étiquettes à l'imprimante, veuillez vous rapprocher de l'administrateur pour remettre les étiquettes à disposition"
								);
							}
						});
					});
			},

			loadProducts({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('search_autocomplete', searchQuery);

					return this.$axios.get(`/api/products?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let label = item.name;

							return {
								'@id': item['@id'],
								name: label,
							};
						});

						if (action === 'ASYNC_SEARCH') {
							callback(null, options);
						}
					});
				}
			},
		},
	};
</script>

<style scoped>
	.q-name p {
		font-weight: bold;
	}
</style>
